(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui-react/icon-message/assets/icon-message.js') >= 0) return;  svs.modules.push('/components/tb-ui-react/icon-message/assets/icon-message.js'); 'use strict';

const Icon = svs.ui.ReactIcon;

const IconMessage = _ref => {
  let {
    children,
    isPadding = false,
    className = '',
    size = '300',
    icon = 'exclamation-sign'
  } = _ref;
  return React.createElement("div", {
    className: "u-flex ".concat(className, " ").concat(isPadding ? 'padding-top-1' : ''),
    style: {
      alignItems: 'center'
    }
  }, React.createElement("div", {
    className: "u-flex padding-right"
  }, React.createElement(Icon, {
    icon: icon,
    size: size
  })), React.createElement("div", {
    className: "u-flex"
  }, children));
};
svs.tb_ui_react.icon_message.IconMessage = IconMessage;
 })(window);